<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            ref="form"
            labelWidth="130px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="true"
            @submit="submit"
            @cancelForm="cancel"
            v-loading="initloading"
          />
        </div>
      </folded-panel>
    </el-card>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel";
  import "@/components/dynamic-form";
  import { updateState, getInfoById } from "@/api/resourceRelease";
  import { getDocumentCode } from '@/views/utils'
  import {parseTime} from "../../../utils"

  export default {
    name: "NewRelease",
    components: {
      FoldedPanel
    },
    data() {
      return {
        initloading: false,
        loading: false,
        form: {},
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "单据编号",
              value: "",
              span: 8,
              disabled: true
            },
            {
              label: "人员",
              key: "personName",
              type: "input",
              placeholder: "请选择人员",
              span: 8,
              disabled: true
            },
            {
              type: "number",
              key: "settlementPrice",
              label: "结算单价",
              placeholder: "请输入结算单价",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "date",
              key: "startTime",
              label: "原资源占用开始日",
              // placeholder: "请选择原资源占用开始日",
              // valueFormat: "yyyy-MM-dd",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "date",
              key: "endTime",
              label: "原资源占用结束日",
              // placeholder: "请选择原资源占用结束日",
              // valueFormat: "yyyy-MM-dd",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "number",
              key: "applyDaysRemainig",
              label: "剩余申请人天",
              placeholder: " 原资源结束日 - 当前日期",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "date",
              key: "resourceOccupationEndtimeNow",
              label: "现资源占用结束日",
              disabled: true,
              value: "",
              span: 8,
              rules: [
                { required: true, message: "现资源占用结束日不能为空", trigger: "blur" }
              ]
            },
            {
              type: "number",
              key: "workDayEstimateNow",
              label: "现工作人天估算",
              placeholder: "请输入现工作人天估算",
              value: "",
              span: 8,
              rules: [
                { required: true, message: "现工作人天估算不能为空", trigger: "blur" }
              ]
            },
            {
              type: "textarea",
              key: "remark",
              label: "备注",
              value: "",
              placeholder: "请输入备注",
              span: 18
            }
          ]
        }
      };
    },
    created() {
      this.initData();
    },
    methods: {
      async initData() {
        if (!this.$route.query.id) {
          return;
        }
        this.initloading = true;
        try {
          const result = await getInfoById(this.$route.query.id)
          this.form = { ...result.data, code: getDocumentCode('ZYSF'), personName: result.data.person.name, personId: result.data.person.id, applyDaysRemainig: parseInt((new Date(result.data.endTime).getTime() - new Date(parseTime(new Date(), '"{y}-{m}-{d}"')).getTime()) / (24 * 60 * 60 * 1000)), resourceOccupationEndtimeNow: new Date() }
          console.log(this.form)
          this.initloading = false;
        } catch (e) {
          this.initloading = false;
        }
      },
      submit() {
        this.$refs["form"].validate().then(() => {
          if (this.form.resourceOccupationEndtimeNow.getTime() + 24 * 60 * 60 * 1000 - 1 < new Date().getTime()) {
            this.$message.warning('资源占用结束日不早于当前日期!')
            return
          }
          this.loading = true;
          updateState(this.form)
            .then(() => {
              this.$notify({
                title: "释放成功",
                type: "success",
                duration: 2500
              });
              this.loading = false;
              this.cancel();
            })
            .catch(() => {
              this.loading = false;
            });
        });
      },
      cancel() {
        this.$router.push("/bill/ReleaseResource")
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
